class FetchAboutCandidates {
	constructor(
		public readonly facilityId: number,
		public readonly typeId: number,
		public readonly search: string,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		return new URLSearchParams({ search: this.search }).toString();
	}
}

export default FetchAboutCandidates;
